import React, { useState, useEffect, useRef, useCallback } from 'react';

// 🤖 Agente de Vendas — QG do projeto (Fase 1 em construção)
// Abas: Simulador (conversar com o motor) · Projeto (fases, decisões,
// cronograma) · Tabela (preços oficiais) · Consumo (tokens de IA).

function token() { return localStorage.getItem('token'); }
async function api(path, opts = {}) {
  const r = await fetch(path, {
    ...opts,
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token()}`, ...(opts.headers || {}) },
  });
  const d = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(d.erro || 'Erro');
  return d;
}

const inp = { padding: '6px 10px', border: '1px solid #d1d5db', borderRadius: 6, fontSize: 13 };
const card = { background: '#fff', border: '1px solid #dbe2ea', borderRadius: 10, padding: 14 };
const h2 = { fontSize: 13, fontWeight: 800, color: '#0a1628', textTransform: 'uppercase', letterSpacing: '.04em', marginBottom: 8 };

// ── Aba Simulador ─────────────────────────────────────────────────────────────

const ACAO_ICONE = { pesquisa: '🔎', tabela: '💰', aprovacao_vagner: '📲', handoff: '🙋', fechamento: '🎉' };

function AbaSimulador() {
  const [msgs, setMsgs] = useState([]);
  const [acoes, setAcoes] = useState([]);
  const [texto, setTexto] = useState('');
  const [enviando, setEnviando] = useState(false);
  const fimRef = useRef(null);
  const sessao = 'simulador_vagner';

  useEffect(() => { fimRef.current?.scrollIntoView({ behavior: 'smooth' }); }, [msgs]);

  async function enviar() {
    const t = texto.trim();
    if (!t || enviando) return;
    setTexto('');
    setMsgs(m => [...m, { de: 'lead', texto: t }]);
    setEnviando(true);
    try {
      const r = await api('/agente-vendas/simular', { method: 'POST', body: JSON.stringify({ sessao, mensagem: t }) });
      setMsgs(m => [...m, { de: 'agente', texto: r.resposta, meta: `${r.modelo_usado.includes('opus') ? '🧠 Opus (difícil)' : '⚡ Sonnet'} · ${r.tokens.in + r.tokens.out} tokens` }]);
      setAcoes(r.acoes_todas || []);
    } catch (e) {
      setMsgs(m => [...m, { de: 'agente', texto: `⚠ ${e.message}`, meta: 'erro' }]);
    }
    setEnviando(false);
  }

  async function resetar() {
    if (!window.confirm('Zerar a conversa do simulador?')) return;
    await api(`/agente-vendas/simular/${sessao}`, { method: 'DELETE' }).catch(() => {});
    setMsgs([]); setAcoes([]);
  }

  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8, flexWrap: 'wrap', gap: 6 }}>
        <div style={{ fontSize: 12, color: '#6b7280' }}>Você é o LEAD. Nada aqui toca cliente real — ações externas são só registradas nos bastidores.</div>
        <button onClick={resetar} style={{ background: '#fff', border: '1px solid #fecaca', color: '#b91c1c', borderRadius: 6, padding: '4px 12px', fontSize: 12, cursor: 'pointer' }}>🗑 Zerar conversa</button>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 300px', gap: 12, alignItems: 'start' }}>
        <div style={{ background: '#efe7dd', border: '1px solid #dbe2ea', borderRadius: 10, display: 'flex', flexDirection: 'column', height: '58vh', minWidth: 0 }}>
          <div style={{ flex: 1, overflowY: 'auto', padding: 14 }}>
            {msgs.length === 0 && (
              <div style={{ textAlign: 'center', color: '#8a8377', fontSize: 12.5, marginTop: 40 }}>
                Comece como um cliente começaria:<br /><em>"oi, queria saber sobre registro de marca"</em>
              </div>
            )}
            {msgs.map((m, i) => (
              <div key={i} style={{ display: 'flex', justifyContent: m.de === 'lead' ? 'flex-end' : 'flex-start', marginBottom: 8 }}>
                <div style={{
                  maxWidth: '78%', padding: '7px 11px', borderRadius: 10, fontSize: 13.5, lineHeight: 1.5, whiteSpace: 'pre-wrap',
                  background: m.de === 'lead' ? '#d9fdd3' : '#fff',
                  borderBottomRightRadius: m.de === 'lead' ? 2 : 10,
                  borderBottomLeftRadius: m.de === 'agente' ? 2 : 10,
                  boxShadow: '0 1px 1px rgba(0,0,0,.08)',
                }}>
                  {m.texto}
                  {m.meta && <div style={{ fontSize: 9.5, color: '#9ca3af', marginTop: 3, textAlign: 'right' }}>{m.meta}</div>}
                </div>
              </div>
            ))}
            {enviando && <div style={{ fontSize: 12, color: '#8a8377' }}>digitando…</div>}
            <div ref={fimRef} />
          </div>
          <div style={{ display: 'flex', gap: 6, padding: 10, borderTop: '1px solid #dbd3c6' }}>
            <input value={texto} onChange={e => setTexto(e.target.value)} onKeyDown={e => e.key === 'Enter' && enviar()}
              placeholder="Escreva como o lead escreveria…" style={{ ...inp, flex: 1, borderRadius: 18, background: '#fff' }} />
            <button onClick={enviar} disabled={enviando} style={{ background: '#0a1628', color: '#fff', border: 'none', borderRadius: 18, padding: '6px 18px', fontSize: 13, fontWeight: 700, cursor: 'pointer', opacity: enviando ? .6 : 1 }}>➤</button>
          </div>
        </div>
        <div style={{ ...card, maxHeight: '58vh', overflowY: 'auto' }}>
          <div style={h2}>Bastidores do agente</div>
          {acoes.length === 0 && <div style={{ fontSize: 12, color: '#9ca3af' }}>As ferramentas que o agente usar (pesquisa, tabela, chamar você, handoff, fechamento) aparecem aqui.</div>}
          {acoes.map((a, i) => (
            <div key={i} style={{ borderLeft: `3px solid ${a.tipo === 'fechamento' ? '#16a34a' : a.tipo === 'handoff' ? '#b45309' : a.tipo === 'aprovacao_vagner' ? '#4c1d95' : '#94a3b8'}`, background: '#f8fafc', borderRadius: 4, padding: '6px 9px', marginBottom: 6 }}>
              <div style={{ fontSize: 11.5, fontWeight: 700, color: '#0a1628' }}>{ACAO_ICONE[a.tipo] || '⚙️'} {a.tipo}</div>
              <div style={{ fontSize: 11.5, color: '#374151' }}>{a.detalhe}</div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

// ── Aba Projeto (a estrutura completa) ────────────────────────────────────────

function Selo({ cor, children }) {
  return <span style={{ background: cor === 'verde' ? '#dcfce7' : cor === 'ambar' ? '#fef3c7' : '#e5e7eb', color: cor === 'verde' ? '#15803d' : cor === 'ambar' ? '#b45309' : '#6b7280', fontSize: 10.5, fontWeight: 800, borderRadius: 4, padding: '1px 8px', whiteSpace: 'nowrap' }}>{children}</span>;
}

function AbaProjeto() {
  const linhaFluxo = (n, t, quem) => (
    <div key={n} style={{ display: 'flex', gap: 8, alignItems: 'baseline', marginBottom: 4 }}>
      <span style={{ background: '#0a1628', color: '#fff', borderRadius: 10, fontSize: 10, fontWeight: 800, padding: '1px 7px', flexShrink: 0 }}>{n}</span>
      <span style={{ fontSize: 12.5, color: '#374151', flex: 1 }}>{t}</span>
      <span style={{ fontSize: 10.5, color: quem === 'você' ? '#4c1d95' : '#9ca3af', fontWeight: quem === 'você' ? 700 : 400, flexShrink: 0 }}>{quem}</span>
    </div>
  );
  return (
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))', gap: 12, alignItems: 'start' }}>

      <div style={card}>
        <div style={h2}>🗓 Cronograma</div>
        {[
          ['Semana 1', 'Contador de consumo + motor do agente + simulador', 'verde', 'ENTREGUE'],
          ['Semana 2', 'Handoff real no seu WhatsApp · follow-ups D+2/5/10 · prompt caching (derruba custo) · painel comparativo', 'ambar', 'PRÓXIMA'],
          ['Semana 3', 'Piloto REAL com 30% dos leads de entrada (sorteio automático)', 'cinza', 'AGUARDA'],
          ['Semanas 4–6', 'Leitura dos números · decisão de ampliar pra 100%', 'cinza', 'AGUARDA'],
          ['Semanas 5–7', 'Fase 2: celular 1 (chip aquecido) rampa 10→40/dia · celular 2 entra depois', 'cinza', 'AGUARDA'],
        ].map(([sem, txt, cor, selo], i) => (
          <div key={i} style={{ display: 'flex', gap: 8, alignItems: 'baseline', marginBottom: 6 }}>
            <Selo cor={cor}>{selo}</Selo>
            <div style={{ fontSize: 12.5 }}><strong>{sem}:</strong> <span style={{ color: '#374151' }}>{txt}</span></div>
          </div>
        ))}
      </div>

      <div style={card}>
        <div style={h2}>⚙️ Fase 1 — o fluxo do agente closer</div>
        {[
          [1, 'Clau qualifica o lead (marca, ramo, Instagram)', 'agente'],
          [2, 'Pesquisa de viabilidade na base de 5,1M de marcas, na hora', 'agente'],
          [3, 'Parecer traduzido: verde/amarelo/vermelho com honestidade', 'agente'],
          [4, 'Proposta com valor DA TABELA e condições oficiais', 'agente'],
          [5, 'Objeções comuns (escala pro modelo forte sozinho)', 'agente'],
          [6, 'Exceções: desconto acima do teto, caso complexo, irritação', 'você'],
          [7, 'Fechamento: Pix/link + confirmação', 'você aprova'],
          [8, 'Follow-up D+2 · D+5 · D+10, depois arquiva', 'agente'],
          [9, 'Pós-venda no fluxo atual (Gravar Cliente → protocolo)', 'fluxo atual'],
        ].map(([n, t, q]) => linhaFluxo(n, t, q))}
      </div>

      <div style={card}>
        <div style={h2}>🔒 As 6 decisões do dono (fechadas 01/08)</div>
        {[
          ['1 · Cobrança', 'Pix à vista · cartão 6x sem juros · até 10x com juros da maquineta · link ou presencial'],
          ['2 · Desconto', 'Até 15% SÓ no Pix, como carta na manga (acima disso o agente te chama). Cartão: zero desconto'],
          ['3 · Robô', 'Nunca se declara nem confirma; desconversa com leveza; insistiu → transfere pra humano'],
          ['4 · Piloto', '30% dos leads de entrada, sorteio automático, funil comparativo agente × time'],
          ['5 · Celulares', '2 aparelhos dedicados — chip 1 já aquecido (confirmar qual número), chip 2 a comprar'],
          ['6 · Time', 'Não sabe do piloto — oportunidades do agente entram no CRM atribuídas a você'],
        ].map(([t, d], i) => (
          <div key={i} style={{ marginBottom: 6 }}>
            <div style={{ fontSize: 12, fontWeight: 700, color: '#4c1d95' }}>{t}</div>
            <div style={{ fontSize: 12, color: '#374151' }}>{d}</div>
          </div>
        ))}
      </div>

      <div style={card}>
        <div style={h2}>📞 Fase 2 — prospecção ativa (resumo)</div>
        <div style={{ fontSize: 12.5, color: '#374151', lineHeight: 1.6 }}>
          Primeiro contato com leads <strong>quentes do Radar RPI</strong> (indeferido sem procurador, pedido publicado sem procurador, exigência com prazo) — mensagem cita um fato real e datado do processo da pessoa.<br />
          <strong>Anti-banimento:</strong> 2 celulares dedicados via ADB · intervalo aleatório 3–8 min · rampa 10 → 40/dia por chip (~80/dia em regime) · aquecimento escalonado · listas segmentadas · semáforo de saúde que reduz a rampa sozinho · chip cai, operação não.
        </div>
      </div>

      <div style={{ ...card, borderColor: '#fde68a', background: '#fffbeb' }}>
        <div style={{ ...h2, color: '#92400e' }}>⏳ Pendências suas</div>
        {[
          'Preencher a TABELA DE PREÇOS real (aba 💰 — está com valor de teste R$ 1.200)',
          'Dizer qual é a maquineta (Stone, PagBank, Mercado Pago…) — habilita o link de pagamento automático',
          '15% do Pix: confirmar carta na manga (padrão atual) ou oferta aberta',
          'Confirmar QUAL é o chip aquecido (não pode ser número da operação)',
          'Testar o simulador com os perfis de lead que você conhece da rua',
        ].map((t, i) => (
          <div key={i} style={{ fontSize: 12.5, color: '#92400e', marginBottom: 4 }}>• {t}</div>
        ))}
      </div>

    </div>
  );
}

// ── Aba Tabela de preços ──────────────────────────────────────────────────────

function AbaTabela() {
  const [cfg, setCfg] = useState(null);
  const [salvando, setSalvando] = useState(false);
  const [msg, setMsg] = useState('');

  const carregar = useCallback(() => { api('/agente-vendas/config').then(setCfg).catch(() => {}); }, []);
  useEffect(() => { carregar(); }, [carregar]);

  if (!cfg) return <div style={{ color: '#9ca3af', fontSize: 13 }}>Carregando…</div>;

  const setPreco = (i, campo, valor) => setCfg(c => {
    const precos = [...(c.precos || [])];
    precos[i] = { ...precos[i], [campo]: valor };
    return { ...c, precos };
  });

  async function salvar() {
    setSalvando(true); setMsg('');
    try { await api('/agente-vendas/config', { method: 'PUT', body: JSON.stringify(cfg) }); setMsg('✅ Salvo — o agente já usa os valores novos.'); }
    catch (e) { setMsg(`⚠ ${e.message}`); }
    setSalvando(false);
    carregar();
  }

  return (
    <div style={{ ...card, maxWidth: 640 }}>
      <div style={h2}>💰 Tabela oficial — única fonte de preço do agente</div>
      <div style={{ fontSize: 12, color: '#6b7280', marginBottom: 10 }}>
        Condições fixas (das suas decisões): Pix à vista com até <strong>{cfg.desconto_max_pix}%</strong> de desconto (carta na manga) · cartão até <strong>{cfg.parcelas_sem_juros}x sem juros</strong> ou <strong>{cfg.parcelas_max}x com juros da maquineta</strong>. Serviço sem valor aqui = o agente se recusa a citar preço.
      </div>
      {(cfg.precos || []).map((p, i) => (
        <div key={i} style={{ display: 'flex', gap: 6, marginBottom: 5 }}>
          <input style={{ ...inp, flex: 1 }} value={p.servico || ''} onChange={e => setPreco(i, 'servico', e.target.value)} placeholder="Serviço (ex.: Registro de Marca)" />
          <input style={{ ...inp, width: 140 }} type="number" value={p.valor || ''} onChange={e => setPreco(i, 'valor', e.target.value)} placeholder="Valor à vista R$" />
          <button onClick={() => setCfg(c => ({ ...c, precos: c.precos.filter((_, j) => j !== i) }))} style={{ background: 'none', border: 'none', color: '#b91c1c', cursor: 'pointer', fontSize: 15 }}>✕</button>
        </div>
      ))}
      <div style={{ display: 'flex', gap: 6, marginTop: 8 }}>
        <button onClick={() => setCfg(c => ({ ...c, precos: [...(c.precos || []), { servico: '', valor: '' }] }))} style={{ background: '#f3f4f6', border: '1px solid #d1d5db', borderRadius: 6, padding: '5px 12px', fontSize: 12, cursor: 'pointer' }}>+ Serviço</button>
        <button onClick={salvar} disabled={salvando} style={{ background: '#0a1628', color: '#fff', border: 'none', borderRadius: 6, padding: '5px 16px', fontSize: 12, fontWeight: 700, cursor: 'pointer' }}>{salvando ? 'Salvando…' : 'Salvar tabela'}</button>
      </div>
      {msg && <div style={{ fontSize: 12, marginTop: 8, color: msg.startsWith('✅') ? '#15803d' : '#b91c1c' }}>{msg}</div>}
      {(cfg.precos || []).length === 0 && <div style={{ fontSize: 12, color: '#b45309', marginTop: 8 }}>⚠ Tabela vazia: o agente não cita valor nenhum até você preencher.</div>}
    </div>
  );
}

// ── Aba Consumo de IA ─────────────────────────────────────────────────────────

const NOME_MODULO = {
  agente_vendas: '🤖 Agente de Vendas', clau_leads: '💬 Clau (leads)', clau_extracao: '🔎 Clau (extração)',
  chat_dono: '👑 Chat do dono', minuta: '⚖️ Minutas', briefing: '🌅 Briefing matinal',
};

function AbaConsumo() {
  const [dias, setDias] = useState(30);
  const [dados, setDados] = useState(null);

  useEffect(() => {
    api(`/ia-consumo/resumo?dias=${dias}`).then(setDados).catch(() => {});
  }, [dias]);

  if (!dados) return <div style={{ color: '#9ca3af', fontSize: 13 }}>Carregando…</div>;
  const fmt = n => (n || 0).toLocaleString('pt-BR');

  return (
    <div>
      <div style={{ display: 'flex', gap: 6, marginBottom: 10, alignItems: 'center' }}>
        {[7, 30, 90].map(d => (
          <button key={d} onClick={() => setDias(d)} style={{ background: dias === d ? '#0a1628' : '#fff', color: dias === d ? '#fff' : '#374151', border: '1px solid #d1d5db', borderRadius: 6, padding: '4px 12px', fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>{d} dias</button>
        ))}
        <span style={{ fontSize: 11.5, color: '#9ca3af' }}>· medição começou em 01/08/2026 — o mês de agosto inteiro é a régua pro custo do piloto</span>
      </div>
      <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', marginBottom: 12 }}>
        {[
          ['Chamadas à IA', fmt(dados.chamadas), '#0a1628'],
          ['Tokens de entrada', fmt(dados.input_tokens), '#0a1628'],
          ['Tokens de saída', fmt(dados.output_tokens), '#0a1628'],
          ['♻️ Lidos do cache', fmt(dados.cache_read_tokens), '#059669'],
        ].map(([l, v, cor], i) => (
          <div key={i} style={{ ...card, padding: '8px 16px', minWidth: 150 }}>
            <div style={{ fontSize: 11, color: '#6b7280' }}>{l}</div>
            <div style={{ fontSize: 18, fontWeight: 800, color: cor }}>{v}</div>
          </div>
        ))}
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: 12, alignItems: 'start' }}>
        <div style={card}>
          <div style={h2}>Por módulo</div>
          {Object.entries(dados.por_modulo || {}).sort((a, b) => (b[1].input_tokens + b[1].output_tokens) - (a[1].input_tokens + a[1].output_tokens)).map(([m, v]) => (
            <div key={m} style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12.5, marginBottom: 5, gap: 8 }}>
              <span style={{ fontWeight: 600, color: '#0a1628' }}>{NOME_MODULO[m] || m}</span>
              <span style={{ color: '#6b7280', whiteSpace: 'nowrap' }}>{fmt(v.chamadas)} ch · {fmt(v.input_tokens + v.output_tokens)} tk</span>
            </div>
          ))}
        </div>
        <div style={card}>
          <div style={h2}>Por modelo</div>
          {Object.entries(dados.por_modelo || {}).map(([m, v]) => (
            <div key={m} style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12.5, marginBottom: 5, gap: 8 }}>
              <span style={{ fontWeight: 600, color: '#0a1628' }}>{m.replace('claude-', '')}</span>
              <span style={{ color: '#6b7280', whiteSpace: 'nowrap' }}>{fmt(v.chamadas)} ch · {fmt(v.input_tokens + v.output_tokens)} tk</span>
            </div>
          ))}
          <div style={{ fontSize: 11, color: '#9ca3af', marginTop: 8, borderTop: '1px dashed #e5e7eb', paddingTop: 6 }}>
            ♻️ Prompt caching ATIVO desde 03/08: tokens lidos do cache custam ~10% do preço normal. Quanto maior o número verde, maior a economia.
          </div>
        </div>
      </div>
    </div>
  );
}

// ── Aba Aquecedor de Chips ────────────────────────────────────────────────────

const STATUS_INFO = {
  aquecendo:   ['🔥 Aquecendo', '#b45309', '#fef3c7'],
  pronto:      ['✅ Pronto', '#15803d', '#dcfce7'],
  em_operacao: ['🚀 Em operação', '#1d4ed8', '#eff6ff'],
  pausado:     ['⏸ Pausado', '#6b7280', '#f3f4f6'],
  banido:      ['⛔ Banido', '#b91c1c', '#fee2e2'],
};

function AbaAquecedor() {
  const [dados, setDados] = useState(null);
  const [novo, setNovo] = useState({ apelido: '', numero: '', papel: 'closer', ja_aquecido: false });
  const [expandido, setExpandido] = useState(null);

  const carregar = useCallback(() => { api('/aquecedor-chips').then(setDados).catch(() => {}); }, []);
  useEffect(() => { carregar(); }, [carregar]);

  async function criar() {
    if (!novo.apelido.trim()) return;
    await api('/aquecedor-chips', { method: 'POST', body: JSON.stringify(novo) }).catch(() => {});
    setNovo({ apelido: '', numero: '', papel: 'closer', ja_aquecido: false });
    carregar();
  }
  async function atualizar(id, campos) {
    await api(`/aquecedor-chips/${id}`, { method: 'PUT', body: JSON.stringify(campos) }).catch(() => {});
    carregar();
  }
  async function remover(id) {
    if (!window.confirm('Remover este chip do aquecedor?')) return;
    await api(`/aquecedor-chips/${id}`, { method: 'DELETE' }).catch(() => {});
    carregar();
  }

  if (!dados) return <div style={{ color: '#9ca3af', fontSize: 13 }}>Carregando…</div>;
  const { chips, plano } = dados;
  const totalDias = 21;

  return (
    <div>
      <div style={{ ...card, background: '#fffbeb', borderColor: '#fde68a', marginBottom: 12, fontSize: 12.5, color: '#92400e' }}>
        <strong>Aquecer ≠ disparar.</strong> O chip novo NÃO manda mensagem pra desconhecido — isso queima. Aquecer é tráfego de verdade:
        receber, responder, e os chips da operação (e o seu número) conversarem entre si. Este painel é o roteiro; quando o celular físico
        (ADB) estiver plugado, ele executa sozinho. Contato quente do Radar RPI só a partir do dia 16, em dose pequena.
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1.2fr 1fr', gap: 12, alignItems: 'start' }}>

        {/* Chips + progresso */}
        <div>
          <div style={{ ...card, marginBottom: 10 }}>
            <div style={h2}>+ Novo chip</div>
            <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', alignItems: 'center' }}>
              <input style={{ ...inp, flex: 1, minWidth: 140 }} value={novo.apelido} onChange={e => setNovo(n => ({ ...n, apelido: e.target.value }))} placeholder="Apelido (ex.: Chip Closer 1)" />
              <input style={{ ...inp, width: 130 }} value={novo.numero} onChange={e => setNovo(n => ({ ...n, numero: e.target.value }))} placeholder="Número (opcional)" />
              <select style={inp} value={novo.papel} onChange={e => setNovo(n => ({ ...n, papel: e.target.value }))}>
                <option value="closer">Closer</option>
                <option value="sdr">SDR</option>
              </select>
              <label style={{ fontSize: 12, color: '#374151', display: 'flex', alignItems: 'center', gap: 4 }}>
                <input type="checkbox" checked={novo.ja_aquecido} onChange={e => setNovo(n => ({ ...n, ja_aquecido: e.target.checked }))} /> já aquecido
              </label>
              <button onClick={criar} style={{ background: '#0a1628', color: '#fff', border: 'none', borderRadius: 6, padding: '6px 14px', fontSize: 12, fontWeight: 700, cursor: 'pointer' }}>Adicionar</button>
            </div>
          </div>

          {chips.length === 0 && <div style={{ ...card, color: '#9ca3af', fontSize: 12.5 }}>Nenhum chip ainda. Adicione o seu chip aquecido e o que vai comprar.</div>}
          {chips.map(c => {
            const [rot, cor, bg] = STATUS_INFO[c.status] || STATUS_INFO.aquecendo;
            const feitos = (c.dias_feitos || []).length;
            const pct = Math.round((feitos / totalDias) * 100);
            const aberto = expandido === c._id;
            return (
              <div key={c._id} style={{ ...card, marginBottom: 8, padding: 12 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
                  <div>
                    <span style={{ fontSize: 13.5, fontWeight: 700, color: '#0a1628' }}>{c.apelido}</span>
                    <span style={{ fontSize: 11, color: '#6b7280', marginLeft: 6 }}>{c.papel === 'sdr' ? '📞 SDR' : '🧭 Closer'}{c.numero ? ` · ${c.numero}` : ''}</span>
                  </div>
                  <div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
                    <select value={c.status} onChange={e => atualizar(c._id, { status: e.target.value })} style={{ ...inp, fontSize: 11, padding: '3px 6px', background: bg, color: cor, fontWeight: 700, border: `1px solid ${cor}` }}>
                      {Object.keys(STATUS_INFO).map(s => <option key={s} value={s}>{STATUS_INFO[s][0]}</option>)}
                    </select>
                    <button onClick={() => setExpandido(aberto ? null : c._id)} style={{ background: '#f3f4f6', border: '1px solid #d1d5db', borderRadius: 6, padding: '3px 10px', fontSize: 11, cursor: 'pointer' }}>{aberto ? 'fechar' : 'plano'}</button>
                    <button onClick={() => remover(c._id)} style={{ background: 'none', border: 'none', color: '#b91c1c', cursor: 'pointer', fontSize: 14 }}>✕</button>
                  </div>
                </div>
                {/* barra de progresso */}
                <div style={{ marginTop: 8 }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 11, color: '#6b7280', marginBottom: 2 }}>
                    <span>Dia {feitos} de {totalDias}</span><span>{pct}%</span>
                  </div>
                  <div style={{ height: 7, background: '#e5e7eb', borderRadius: 4, overflow: 'hidden' }}>
                    <div style={{ width: `${pct}%`, height: '100%', background: c.status === 'pronto' || c.status === 'em_operacao' ? '#16a34a' : '#f59e0b' }} />
                  </div>
                </div>
                {/* grade de 21 dias clicáveis */}
                {aberto && (
                  <div style={{ marginTop: 10 }}>
                    <div style={{ display: 'flex', gap: 4, flexWrap: 'wrap', marginBottom: 8 }}>
                      {Array.from({ length: totalDias }, (_, i) => i + 1).map(d => {
                        const ok = (c.dias_feitos || []).includes(d);
                        return (
                          <button key={d} onClick={() => atualizar(c._id, { toggle_dia: d })}
                            title={`Dia ${d} — clique pra marcar`}
                            style={{ width: 26, height: 26, borderRadius: 5, fontSize: 11, fontWeight: 700, cursor: 'pointer',
                              border: `1px solid ${ok ? '#16a34a' : '#d1d5db'}`, background: ok ? '#16a34a' : '#fff', color: ok ? '#fff' : '#9ca3af' }}>{ok ? '✓' : d}</button>
                        );
                      })}
                    </div>
                    <textarea value={c.observacoes || ''} onChange={e => atualizar(c._id, { observacoes: e.target.value })}
                      placeholder="Observações do chip (entregas, bloqueios, o que notou…)"
                      rows={2} style={{ ...inp, width: '100%', boxSizing: 'border-box', resize: 'vertical', fontSize: 12 }} />
                  </div>
                )}
              </div>
            );
          })}
        </div>

        {/* Plano de 21 dias */}
        <div style={card}>
          <div style={h2}>📋 O ritual de 21 dias</div>
          {plano.map((f, i) => (
            <div key={i} style={{ marginBottom: 9, paddingLeft: 8, borderLeft: '3px solid #f59e0b' }}>
              <div style={{ fontSize: 12.5, fontWeight: 700, color: '#0a1628' }}>Dias {f.dias} · {f.fase} <span style={{ color: '#b45309', fontWeight: 400 }}>· teto {f.teto_envios} envios/dia</span></div>
              {f.metas.map((m, j) => <div key={j} style={{ fontSize: 12, color: '#374151' }}>• {m}</div>)}
            </div>
          ))}
          <div style={{ fontSize: 11, color: '#9ca3af', borderTop: '1px dashed #e5e7eb', paddingTop: 6, marginTop: 4 }}>
            Regra de ouro: <strong>receber ≥ enviar</strong> todos os dias. Chip pronto só quando os 21 dias estão marcados — aí o semáforo abre pra Fase 2.
          </div>
        </div>

      </div>
    </div>
  );
}

// ── Página ────────────────────────────────────────────────────────────────────

export default function AgenteVendas() {
  const [aba, setAba] = useState('simulador');
  const ABAS = [
    { k: 'simulador', label: '💬 Simulador' },
    { k: 'aquecedor', label: '🔥 Aquecedor de Chips' },
    { k: 'projeto', label: '📋 Projeto' },
    { k: 'tabela', label: '💰 Tabela de preços' },
    { k: 'consumo', label: '📊 Consumo de IA' },
  ];
  return (
    <div style={{ maxWidth: 1080 }}>
      <div style={{ marginBottom: 10 }}>
        <h1 style={{ fontSize: 17, fontWeight: 700, color: '#0a1628', margin: 0 }}>🤖 Agente de Vendas</h1>
        <div style={{ fontSize: 12, color: '#6b7280' }}>Fase 1 em construção · semana 1 entregue · modo SIMULADOR (nenhum lead real passa por aqui)</div>
      </div>
      <div style={{ display: 'flex', gap: 0, marginBottom: 14, borderBottom: '2px solid #e5e7eb' }}>
        {ABAS.map(({ k, label }) => (
          <button key={k} onClick={() => setAba(k)} style={{
            background: 'none', border: 'none', borderBottom: aba === k ? '2px solid #0a1628' : '2px solid transparent',
            marginBottom: -2, padding: '8px 16px', fontSize: 13, fontWeight: aba === k ? 700 : 400,
            color: aba === k ? '#0a1628' : '#6b7280', cursor: 'pointer',
          }}>{label}</button>
        ))}
      </div>
      {aba === 'simulador' && <AbaSimulador />}
      {aba === 'aquecedor' && <AbaAquecedor />}
      {aba === 'projeto' && <AbaProjeto />}
      {aba === 'tabela' && <AbaTabela />}
      {aba === 'consumo' && <AbaConsumo />}
    </div>
  );
}
